import { Table } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { Button, NumberFormatter } from "components";
import { TFunction } from "i18next";
import { useEffect, useState } from "react";
import { CreditRequestPayment } from "types"
import { AppUtils, UserUtils } from "utils";
import DeleteModal from "./delete";
import { AuthorityConstants, ServiceConstants } from "constant";
import { useSelector } from "react-redux";
import { IRootState } from "config/redux";

const { ROLE_CR_C, ROLE_CR_U } = AuthorityConstants;
const { REQUEST_CREDIT_PAYMENT_DELETE_ID } = ServiceConstants;

interface CreditPaymentStructureListItemProps {
  item: CreditRequestPayment;
  index: number;
  removePayment: (id: number) => void;
  t: TFunction;
}
const CreditPaymentStructureListItem = ({ item, index, removePayment, t }: CreditPaymentStructureListItemProps) => {

  const deleteServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_PAYMENT_DELETE_ID + item.id]);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  useEffect(() => {
    AppUtils.resolveServiceObject(deleteServiceObject, REQUEST_CREDIT_PAYMENT_DELETE_ID + item.id, (val) => {
      removePayment(item.id);
      setDeleteModal(false);
    })
  }, [deleteServiceObject]);

  return (
    <Table.Tr key={`credit-payment-${index}`} bg={'var(--mantine-color-gray-1)'}>
      <Table.Td>{t(`credit.payment.type.options.${item.type}`)}</Table.Td>
      <Table.Td>{item.bank && t(`credit.bank.options.${item.bank}`)}</Table.Td>
      <Table.Td><NumberFormatter value={item.amount} decimalScale={2} fixedDecimalScale={true} /></Table.Td>
      <Table.Td ta={'right'}>
        {UserUtils.hasAnyAuthority([ROLE_CR_C, ROLE_CR_U]) &&
          <>
            <Button
              size={'compact-xs'}
              variant={'transparent'}
              c={'var(--mantine-color-error)'}
              onClick={() => setDeleteModal(true)}
            >
              <IconX size={18} />
            </Button>
            <DeleteModal
              item={item}
              opened={deleteModal}
              onClose={() => setDeleteModal(false)}
              t={t}
            />
          </>
        }
      </Table.Td>
    </Table.Tr>
  )
}

export default CreditPaymentStructureListItem;